import { Box } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import { SIDEBAR_WIDTH } from './constants';

import { color } from 'theme/selectors';

export const SidebarContainer = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 56px;
    bottom: 0;
    width: ${SIDEBAR_WIDTH}px;
    padding: 8px 16px 24px;
    background: ${color('surface-default')};
    box-shadow: 0 4px 12px rgb(0 0 0 / 12%);
    z-index: var(--sidebar-z-index);
    left: ${({ isOpen }) => (isOpen ? '0' : `-${SIDEBAR_WIDTH}px)`)};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transition: all 0.3s;
    overflow-y: auto;
`;

export const SideBarOverlay = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${color('surface-main')};
    z-index: var(--sidebar-overlay-z-index);
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    opacity: ${({ isOpen }) => (isOpen ? '0.8' : '0')};
    transition: all 0.3s;
`;

export const Divider = styled.div`
    width: 100%;
    min-height: 1px;
    background-color: ${color('border-default')};
`;

export const LinksContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-top: 32px;
`;

const commonSecondaryButtonStyles = css`
    display: table;
    cursor: pointer;
    &:hover {
        * {
            color: ${color('text-secondary')};
        }
    }
`;

export const SecondaryLinkButton = styled.a`
    ${commonSecondaryButtonStyles}
`;

export const SecondaryNavButton = styled.button`
    text-align: left;
    ${commonSecondaryButtonStyles};
`;
